import React from 'react';

interface Props  {
  issueId?: string;
  activePanel: string;
}
const LinkedPlans: React.FC<Props> = (props: Props) => {
  return (
    <div>
      Linked plans
    </div>
  );
};

export default LinkedPlans;
